/**
 * 相手のアプリの画面を開いたときの案内(2026-10-23 Gate と Board を別のアプリに)。
 * いまのアプリでは出さない画面のかわりに出し、相手のアプリの同じ画面へのリンクを置く。データは共通なので、相手のアプリでも同じものが見える
 */
import { useLocation } from 'react-router-dom';
import { APP, APP_NAMES, appBaseUrl, appOfPath } from './appTarget';

export default function OtherAppNotice() {
  const { pathname, search } = useLocation();
  const owner = appOfPath(pathname);
  const base = appBaseUrl(owner, import.meta.env);
  return (
    <section className="screen">
      <div className="card">
        <h3>この画面は {APP_NAMES[owner]} にあります</h3>
        <p className="hint" style={{ margin: '0 0 12px' }}>
          {APP === 'gate'
            ? 'PL・予算・CF などの「見る」画面は Nexus Board に分かれました。同じ ID・パスワードで開けます。'
            : '申請・承認・支払・請求などの「入力」の画面は Nexus Gate にあります。同じ ID・パスワードで開けます。'}
        </p>
        {base ? (
          // 相手のアプリは新しいタブで開く(2026-10-23 発注者指示)
          <a
            className="btn-green"
            style={{ display: 'inline-block', textDecoration: 'none' }}
            href={`${base}${pathname}${search}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {APP_NAMES[owner]} で開く
          </a>
        ) : (
          <p className="hint">{APP_NAMES[owner]} の URL がまだ設定されていません(管理者に確認してください)。</p>
        )}
      </div>
    </section>
  );
}
